/* Honest Dog Co - UpCart drawer additions (added 11 Sep 2026)
   1. "You're saving £X today" line above the checkout button
      = subscription savings + compare-at savings (incl. free gift) + any discounts
   2. Hides "Size: Pouch" / "Size: 1 Pouch" on single-pouch lines (multipack sizes stay visible)
   Reads /cart.js; UpCart renders in an open shadow root, so we observe that. */
(function () {
  if (window.__hdcDrawer) return;
  window.__hdcDrawer = true;

  var GREEN = '#2ea818';
  var NAVY = '#1A2D50';
  var MIN_SAVING = 100; // pence - don't show trivial savings

  var host = null;
  var productCache = {};
  var lastSig = '';
  var lastSavings = 0;
  var timer = null;
  var busy = false;

  function root() {
    if (host && host.isConnected && host.shadowRoot) return host.shadowRoot;
    var divs = document.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      var s = divs[i].shadowRoot;
      if (s && s.querySelector('[class*="upcart"]')) { host = divs[i]; return s; }
    }
    return null;
  }

  function money(p) { return '\u00A3' + (p / 100).toFixed(2); }

  function compareAt(handle, variantId) {
    if (!handle) return Promise.resolve(0);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle].then(function (p) {
      if (!p || !p.variants) return 0;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].id === variantId) return p.variants[i].compare_at_price || 0;
      }
      return 0;
    });
  }

  function savingsFor(cart) {
    return Promise.all(cart.items.map(function (it) {
      var discount = it.total_discount || 0;
      var plan = it.selling_plan_allocation;
      if (plan) {
        var planSaving = plan.compare_at_price > plan.price ? (plan.compare_at_price - plan.price) * it.quantity : 0;
        return Promise.resolve(planSaving + discount);
      }
      return compareAt(it.handle, it.variant_id).then(function (cmp) {
        var base = it.original_price;
        return (cmp > base ? (cmp - base) * it.quantity : 0) + discount;
      });
    })).then(function (parts) {
      return parts.reduce(function (a, b) { return a + b; }, 0);
    });
  }

  function checkoutButton(footer) {
    var els = footer.querySelectorAll('button, a');
    for (var i = 0; i < els.length; i++) {
      if (/checkout/i.test(els[i].textContent || '')) return els[i];
    }
    return null;
  }

  function render(s, savings) {
    var footer = s.querySelector('.upcart-footer');
    var el = s.getElementById ? s.getElementById('hdc-savings') : s.querySelector('#hdc-savings');
    if (!footer || savings < MIN_SAVING) { if (el) el.remove(); return; }
    var btn = checkoutButton(footer);
    if (!btn) return;
    var anchor = btn;
    while (anchor.parentNode && anchor.parentNode !== footer) anchor = anchor.parentNode;
    if (anchor.parentNode !== footer) return;
    if (!el) {
      el = document.createElement('div');
      el.id = 'hdc-savings';
      el.setAttribute('style', 'text-align:center;font-size:14px;line-height:1.3;color:' + NAVY + ';padding:0 8px 10px;');
    }
    var html = 'You\u2019re saving <strong style="color:' + GREEN + ';font-weight:700;">' + money(savings) + '</strong> today';
    if (el.innerHTML !== html) el.innerHTML = html;
    if (el.parentNode !== footer || el.nextSibling !== anchor) footer.insertBefore(el, anchor);
  }

  function tidySizes(s) {
    var opts = s.querySelectorAll('.upcart-item-option');
    for (var i = 0; i < opts.length; i++) {
      var v = opts[i].querySelector('.upcart-item-option-value');
      if (v && /^\s*(1\s*)?pouch\s*$/i.test(v.textContent) && opts[i].style.display !== 'none') {
        opts[i].style.display = 'none';
      }
    }
  }

  function signature(s) {
    var footer = s.querySelector('.upcart-footer');
    var btn = footer && checkoutButton(footer);
    var items = s.querySelectorAll('.upcart-product-item');
    var parts = [btn ? btn.textContent : '', items.length];
    for (var i = 0; i < items.length; i++) {
      var q = items[i].querySelector('input');
      parts.push((items[i].textContent || '').length + ':' + (q ? q.value : ''));
    }
    return parts.join('|');
  }

  function update() {
    var s = root();
    if (!s) return;
    tidySizes(s);
    var sig = signature(s);
    if (sig === lastSig) { render(s, lastSavings); return; }
    if (busy) { schedule(); return; }
    busy = true;
    lastSig = sig;
    refresh(s).then(function () {
      busy = false;
      // the free gift is added by another script a moment after add-to-cart; re-check once
      setTimeout(function () { if (lastSig === sig) refresh(s); }, 1200);
    });
  }

  function refresh(s) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(savingsFor)
      .then(function (v) { lastSavings = v; render(s, v); })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 150);
  }

  var tries = 0;
  var poll = setInterval(function () {
    var s = root();
    tries++;
    if (s) {
      clearInterval(poll);
      new MutationObserver(schedule).observe(s, { childList: true, subtree: true, characterData: true });
      update();
    } else if (tries > 60) {
      clearInterval(poll);
    }
  }, 1000);
})();
